import { useMemo } from 'react';
import type { MediaProjectInstanceResponse } from '../types';
import { isBrightColor } from '../utils';
import type { CustomTheme } from './useDefaultTheme';

const DEFAULT_PRIMARY_COLOR = '#35CDBE';
const DEFAULT_SECONDARY_COLOR = '#666666';

/**
 * Derives the final theme by applying publication palette colors to base theme.
 * Handles color brightness checks to ensure readability.
 */
export const useDerivedTheme = (
  baseTheme: CustomTheme,
  publication: MediaProjectInstanceResponse | undefined,
): CustomTheme => {
  return useMemo(() => {
    if (!publication?.palette) return baseTheme;

    let primary = publication.palette?.primary_color ?? DEFAULT_PRIMARY_COLOR;
    const secondary =
      publication.palette?.secondary_color ?? DEFAULT_SECONDARY_COLOR;
    const highlight =
      publication.palette?.highlight_color ?? baseTheme.colors.highlight;
    if (isBrightColor(primary, 180)) {
      primary = isBrightColor(secondary, 180)
        ? DEFAULT_PRIMARY_COLOR
        : secondary;
    }

    return {
      ...baseTheme,
      colors: {
        ...baseTheme.colors,
        primary,
        secondary,
        highlight,
      },
    };
  }, [baseTheme, publication?.palette]);
};
